import { popularComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function FeaturedComics() {
  return (
    <section id="featured" className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">热门推荐</h2>
          <p className="text-sm text-foreground-500 mt-1">最受欢迎的韩国漫画，大家都在看的精选韩漫</p>
        </div>
        <a
          href="#"
          className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-500 transition-colors whitespace-nowrap"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
        {popularComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}